<template>
  <Loader class="shop-product" :promise="promises.fetchOne">
    <ProductDetails v-if="item.id" :value="{ product: item }" />
  </Loader>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import ProductDetails from '@kvass/shop/src/Product/Details'

export default {
  props: {
    id: String,
  },
  watch: {
    id: {
      handler: 'fetch',
      immediate: true,
    },
  },
  computed: {
    ...mapState('Product', ['item', 'promises']),
  },
  methods: {
    ...mapActions('Product', {
      fetch(dispatch) {
        return dispatch('fetch', [{ id: this.id }, { query: 'ShopProduct' }]).then(() => {
          if (!this.item.id) return this.$router.replace({ name: 'notfound' })
        })
      },
    }),
  },
  metaInfo() {
    return {
      title: `${this.$path('item.name')} - ${this.$tc('product', 1)}`,
    }
  },
  components: {
    ProductDetails,
  },
}
</script>

<style lang="scss">
.shop-product {
  --shop-sidebar-width: 500px;

  padding: 2rem;

  display: grid;

  .shop-product-details__images {
    max-height: initial;
  }

  @container (max-width: 1000px) {
    .shop-product-details__images {
      max-height: 85dvh;
    }
    .shop-product-images__slider {
      aspect-ratio: var(--max-ratio);
    }
  }
}
</style>
